'use strict';
import { AppInsights } from "applicationinsights-js";
import AppInsightsUsage from "appinsights-usage";
import WebConfig from "./WebConfig";

class AppInsightsInit {
  static init(appInsightsOptions) {
    if (!appInsightsOptions) {
      appInsightsOptions = WebConfig.appInsightsOptions;
    }
    AppInsights.downloadAndSetup(appInsightsOptions);
    AppInsightsUsage.init(appInsightsOptions);
    this.setAppContext({ urlReferrer: document.referrer });
  }

  static ai() {
    return AppInsights;
  }

  static trackRouterChange() {
    AppInsights.trackPageView();
  }

  static setAppContext(properties) {
    AppInsights.queue.push(function () {
      AppInsights.context.addTelemetryInitializer(function (envelope) {
        let telemetryItem = envelope.data.baseData;

        // To set custom properties:
        telemetryItem.properties = telemetryItem.properties || {};
        for (let key in properties) {
          telemetryItem.properties[key] = properties[key];
        }
      });
    });
  }
}

export default AppInsightsInit;